import React from 'react';

export const IncrementIcon = () => (
  <svg fill='currentColor' width='10' height='5' viewBox='0 0 10 5'>
    <path d='M0,5l5,-5l5,5Z' />
  </svg>
);
export const DecrementIcon = () => (
  <svg fill='currentColor' width='10' height='5' viewBox='0 0 10 5'>
    <path d='M0,0l10,0l-5,5Z' />
  </svg>
);
